import { useContext, useMemo } from "react"
import ListItemDropDown from "components/list-item-dropdown"
import { METRIC_OPTIONS } from "helpers/metrics/definitions"
import { MODEL_METADATA_SHAPE } from "connected-components/asset-view/prop-types"
import { useAnalytics } from "connected-components/analytics"
import { useAssetViewHeaderHandlers } from "connected-components/asset-view/hooks/use-asset-view-header-handlers"
import { FACTOR_SENSITIVITY_CONTEXT } from "./context"

export default function FactorSensitivityHeader({ modelMetadata }) {
  const factorSensitivityContext = useContext(FACTOR_SENSITIVITY_CONTEXT)
  const { selectedMetricDisplay, setSelectedMetricDisplay, selectedCategory, setSelectedCategory } = factorSensitivityContext

  const analytics = useAnalytics()
  const { handleMetricDisplayChange, handleCategoryChange } = useAssetViewHeaderHandlers({
    track: analytics.track,
    setSelectedMetricDisplay,
    setSelectedCategory,
  })

  const displayOptions = useMemo(() => METRIC_OPTIONS.factorSensitivity.map(({ id, label, isDefault, secondaryText, tooltip }) => ({ id, primaryText: label, isDefault, secondaryText, tooltip })), [])

  const categoryOptions = useMemo(() => modelMetadata.categories.map(({ id, label }) => ({ id, primaryText: label })), [modelMetadata])

  return <>
    <ListItemDropDown
      label="Display"
      value={selectedMetricDisplay}
      setValue={handleMetricDisplayChange}
      options={displayOptions}
      alignMenu="left"
    />
    <ListItemDropDown
      label="Factor view"
      value={selectedCategory}
      setValue={handleCategoryChange}
      options={categoryOptions}
      alignMenu="left"
      disablePortal
    />
  </>
}

FactorSensitivityHeader.propTypes = {
  modelMetadata: MODEL_METADATA_SHAPE.isRequired,
}
